import { render, staticRenderFns } from "./EmailFormItem.vue?vue&type=template&id=601b180c&scoped=true&"
import script from "./EmailFormItem.vue?vue&type=script&lang=js&"
export * from "./EmailFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../BougeMaVille-reborn-client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601b180c",
  null
  
)

export default component.exports